module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_h_l1_dark.366f334b.svg";